import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=525765f0&scoped=true&"
import script from "./contextmenu.vue?vue&type=script&lang=js&"
export * from "./contextmenu.vue?vue&type=script&lang=js&"
import style0 from "./contextmenu.vue?vue&type=style&index=0&id=525765f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525765f0",
  null
  
)

export default component.exports